<template>
    <!-- Selector segmentado (cantidad de personas, sí / no) con indicador
         que se desliza hasta la opción elegida. Flechas ← → para moverse. -->
    <div class="nf-segmented" :class="{ 'has-value': hasValue }" role="radiogroup" @keydown="onKey">
        <span ref="ind" class="nf-seg-indicator" aria-hidden="true"></span>
        <button
            v-for="it in items"
            :key="String(it.value)"
            ref="btns"
            type="button"
            class="nf-seg-btn"
            role="radio"
            :aria-checked="isSel(it) ? 'true' : 'false'"
            @click="$emit('input', it.value)"
        >{{ it.label }}</button>
    </div>
</template>

<script>
export default {
    name: 'NfSegmented',
    props: {
        items: { type: Array, required: true }, // [{ value, label }]
        value: { default: null },
    },
    computed: {
        hasValue() { return this.value !== null && this.value !== '' && this.value !== undefined },
    },
    watch: {
        value() { this.$nextTick(this.position) },
        items() { this.$nextTick(this.position) },
    },
    mounted() {
        this.position()
        // Al aparecer dentro de un bloque animado o cambiar el ancho, recalcular.
        if (window.ResizeObserver) {
            this.ro = new ResizeObserver(() => this.position())
            this.ro.observe(this.$el)
        }
    },
    beforeDestroy() {
        if (this.ro) this.ro.disconnect()
    },
    methods: {
        isSel(it) { return this.hasValue && String(it.value) === String(this.value) },
        position() {
            const btns = this.$refs.btns || []
            const i = this.items.findIndex(this.isSel)
            const ind = this.$refs.ind
            const sel = btns[i]
            if (!ind || !sel || !sel.offsetWidth) return
            ind.style.width = sel.offsetWidth + 'px'
            ind.style.transform = `translateX(${sel.offsetLeft}px)`
        },
        onKey(e) {
            if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return
            const btns = this.$refs.btns || []
            const i = btns.indexOf(document.activeElement)
            if (i < 0) return
            e.preventDefault()
            const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length
            btns[n].focus()
            this.$emit('input', this.items[n].value)
        },
    },
}
</script>
